export const reducer = (state, action) => {
  switch (action.type) {
    case 'invalidLogin':
      return {
        ...state,
        invalidLogin: action.value,
      };
    case 'workerLoggedIn':
      return {
        ...state,
        workerLoggedIn: action.value,
      };
    case 'adminLoggedIn':
      return {
        ...state,
        adminLoggedIn: action.value,
      };

    default:
      return state;
  }
};

export const initialState = {
  invalidLogin: false,
};
